import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgRegisterLibrary = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "register_library",
	"data-name": "register library",
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 21 21",
	...props,
	children: [
		/* @__PURE__ */ _jsxs("g", {
			id: "Rectangle_1242",
			"data-name": "Rectangle 1242",
			fill: "none",
			stroke: "#fff",
			strokeWidth: 1,
			children: [/* @__PURE__ */ _jsx("rect", {
				width: 21,
				height: 21,
				stroke: "none"
			}), /* @__PURE__ */ _jsx("rect", {
				x: .5,
				y: .5,
				width: 20,
				height: 20,
				fill: "none"
			})]
		}),
		/* @__PURE__ */ _jsx("circle", {
			id: "Ellipse_256",
			"data-name": "Ellipse 256",
			cx: .75,
			cy: .75,
			r: .75,
			transform: "translate(4 4)",
			fill: "#fff"
		}),
		/* @__PURE__ */ _jsx("circle", {
			id: "Ellipse_261",
			"data-name": "Ellipse 261",
			cx: .75,
			cy: .75,
			r: .75,
			transform: "translate(4 9.75)",
			fill: "#fff"
		}),
		/* @__PURE__ */ _jsx("circle", {
			id: "Ellipse_264",
			"data-name": "Ellipse 264",
			cx: .75,
			cy: .75,
			r: .75,
			transform: "translate(4 15.5)",
			fill: "#fff"
		}),
		/* @__PURE__ */ _jsx("circle", {
			id: "Ellipse_257",
			"data-name": "Ellipse 257",
			cx: .75,
			cy: .75,
			r: .75,
			transform: "translate(9.75 4)",
			fill: "#fff"
		}),
		/* @__PURE__ */ _jsx("circle", {
			id: "Ellipse_260",
			"data-name": "Ellipse 260",
			cx: .75,
			cy: .75,
			r: .75,
			transform: "translate(9.75 9.75)",
			fill: "#fff"
		}),
		/* @__PURE__ */ _jsx("circle", {
			id: "Ellipse_263",
			"data-name": "Ellipse 263",
			cx: .75,
			cy: .75,
			r: .75,
			transform: "translate(9.75 15.5)",
			fill: "#fff"
		}),
		/* @__PURE__ */ _jsx("circle", {
			id: "Ellipse_258",
			"data-name": "Ellipse 258",
			cx: .75,
			cy: .75,
			r: .75,
			transform: "translate(15.5 4)",
			fill: "#fff"
		}),
		/* @__PURE__ */ _jsx("circle", {
			id: "Ellipse_259",
			"data-name": "Ellipse 259",
			cx: .75,
			cy: .75,
			r: .75,
			transform: "translate(15.5 9.75)",
			fill: "#fff"
		}),
		/* @__PURE__ */ _jsx("circle", {
			id: "Ellipse_262",
			"data-name": "Ellipse 262",
			cx: .75,
			cy: .75,
			r: .75,
			transform: "translate(15.5 15.5)",
			fill: "#fff"
		})
	]
});
export default SvgRegisterLibrary;
